import { Routes } from '@angular/router';

import { authGuard } from './core/guards/auth.guard';
import { adminGuard } from './core/guards/admin.guard';
import { csmRestrictedGuard } from './core/guards/csm-restricted.guard';
import { technicianPerformanceGuard } from './core/guards/technician-performance.guard';
import { operationsOnlyGuard } from './core/guards/operations-only.guard';
import { Login } from './features/auth/login/login';
import { Home } from './features/home/home';
import { DealerList } from './features/dealers/dealer-list/dealer-list';
import { VehicleList } from './features/vehicles/vehicle-list/vehicle-list';
import { PartList } from './features/inventory/part-list/part-list';
import { JobList } from './features/jobs/job-list/job-list';
import { TechnicianList } from './features/technicians/technician-list/technician-list';
import { ScheduleView } from './features/scheduling/schedule-view/schedule-view';
import { NotificationList } from './features/notifications/notification-list/notification-list';
import { MyJobs } from './features/technicians/my-jobs/my-jobs';
import { TechnicianInventory } from './features/technicians/technician-inventory/technician-inventory';

export const routes: Routes = [
  { path: 'login', component: Login },
  { path: 'survey/:token', loadComponent: () => import('./features/survey/survey-page/survey-page').then((m) => m.SurveyPage) },
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: Home, canActivate: [authGuard] },
  { path: 'dealers', component: DealerList, canActivate: [authGuard, csmRestrictedGuard] },
  { path: 'dealer-map', loadComponent: () => import('./features/dealers/dealer-map/dealer-map').then((m) => m.DealerMap), canActivate: [authGuard] },
  { path: 'vehicles', component: VehicleList, canActivate: [authGuard, csmRestrictedGuard] },
  { path: 'inventory', component: PartList, canActivate: [authGuard, csmRestrictedGuard] },
  { path: 'jobs', component: JobList, canActivate: [authGuard, csmRestrictedGuard] },
  { path: 'technicians', component: TechnicianList, canActivate: [authGuard, adminGuard] },
  { path: 'scheduling', component: ScheduleView, canActivate: [authGuard] },
  { path: 'notifications', component: NotificationList, canActivate: [authGuard, csmRestrictedGuard] },
  { path: 'my-jobs', component: MyJobs, canActivate: [authGuard, csmRestrictedGuard] },
  { path: 'technician-inventory', component: TechnicianInventory, canActivate: [authGuard, csmRestrictedGuard] },
  {
    path: 'technician-performance',
    loadComponent: () => import('./features/technicians/technician-performance/technician-performance').then((m) => m.TechnicianPerformance),
    canActivate: [authGuard, technicianPerformanceGuard]
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./features/dashboard/dashboard').then((m) => m.Dashboard),
    canActivate: [authGuard, operationsOnlyGuard]
  },
  {
    path: 'nearby-dealers',
    loadComponent: () => import('./features/technicians/nearby-dealers/nearby-dealers').then((m) => m.NearbyDealers),
    canActivate: [authGuard, csmRestrictedGuard]
  },
  {
    path: 'clock-in-out',
    loadComponent: () => import('./features/technicians/clock-in-out/clock-in-out').then((m) => m.ClockInOut),
    canActivate: [authGuard, csmRestrictedGuard]
  }
];
